const fetch = require("node-fetch");
const api_key = "5b3ce3597851110001cf624894e1347fc33b40379a3649c56470ed52";

export async function getOptimalRoute(positions, nVehicles){
    console.log("Getting optimal route for ", nVehicles);
    const request = formatRequest(positions, nVehicles);
    const responseJson = await sendRouteRequest(request);
    return formatResponse(responseJson);
}

export async function getAddressFromCoords(location){
    const responseJson = await sendAddressRequest(location);
    return responseJson;
}


function formatRequest(positions, nVehicles){
    let vehicles = [];

    for (let v=0; v<nVehicles; v++) {
        vehicles.push(
            {
                id: v,
                profile: 'driving-car',
                capacity: [10],
                skills: [1,10],
                //time_window: [1590053791,1590056800],
                start: [positions[0][1], positions[0][0]],
                end: [positions[0][1], positions[0][0]]
            }
        );
    }


    positions.splice(0, 1);

    const jobs = [];
    positions.forEach( (position, index) => {
        jobs.push({
            id: index,
            service:300,
            delivery: [1],
            //pickup:[1],
            skills: [1],
            location: position.reverse(),
        })
    });

    const options = {
        g: true
    }

    console.log(jobs)
    return {jobs, vehicles, options};
}


async function sendAddressRequest(location) {
    const response = await fetch('https://api.openrouteservice.org/geocode/reverse?api_key=' 
    + api_key + '&point.lon=' + location.lng + '&point.lat=' + location.lat);
    const json = response.json();

    return json;
}

async function sendRouteRequest(request) {
    const response = await fetch('https://api.openrouteservice.org/optimization', {
        method: 'POST',
        body: JSON.stringify(request),
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + api_key
        }
    });

    return response.json();
}

function formatResponse(responseJson) {

    if(responseJson.code == 0) {
        const duration = responseJson.summary.duration;
        const distance = responseJson.summary.distance;

        const routes = responseJson.routes.map( route => {
            const trip = route.steps?.map( step => {
                return {
                    id: step.job ?? -1,
                    location: step.location.reverse()
                }
            })
            return {
                distance: route.distance,
                duration: route.duration,
                trip: trip,
                geometry: route.geometry
            }
        })

        return {duration, distance, routes};
    }
    else {
        throw new Error("No route available");
    }
    
}